import { useQuery, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export interface SupportUnreadCounts {
  tickets: number;
  suggestions: number;
  bugReports: number;
  problemReports: number;
}

const EMPTY: SupportUnreadCounts = { tickets: 0, suggestions: 0, bugReports: 0, problemReports: 0 };

/**
 * Per-tab unread counts for the support admin nav badges. Polls periodically so
 * new submissions surface without a manual refresh, and exposes an invalidator
 * the detail/dialog views call after marking an item read.
 */
export function useSupportUnreadCounts() {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: queryKeys.customerSupport.adminUnreadCounts(),
    queryFn: () => api.getSupportUnreadCounts(),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });

  return {
    counts: query.data ?? EMPTY,
    refresh: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.customerSupport.adminUnreadCounts(),
      });
      // Reading items also changes the derived worktop badge (support is an
      // admin-facing derived adapter on the notification summary), so refresh
      // that too — otherwise the tile badge lags until the next poll.
      queryClient.invalidateQueries({ queryKey: queryKeys.notifications.summary() });
    },
  };
}
